import React, { useState, useCallback } from "react";
import { CiSearch } from "react-icons/ci";
import { IoMdClose } from "react-icons/io";

interface SearchInputProps {
  setSearchTerm: (term: string) => void;
  setPageNumber: (pageNumber: number) => void;
  placeholder: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  setSearchTerm,
  setPageNumber,
  placeholder,
}) => {
  const [searchQuery, setSearchQuery] = useState("");

  // custom debounce fn
  const useDebounce = (fn: Function, delay: number) => {
    let timeout: NodeJS.Timeout;

    // return function that takes arg and apply to the function
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    };
  };

  const debouncedSearch = useDebounce((value: string) => {
    setPageNumber(1);
    setSearchTerm(value);
  }, 500); // Reduced delay for better UX

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setSearchQuery(value);
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  const handleClearSearch = useCallback(() => {
    setSearchQuery("");
    setPageNumber(1);
    setSearchTerm("");
  }, [setPageNumber, setSearchTerm]);

  return (
   
      <div className="flex w-full rounded-lg bg-white border border-[#EAEAEA] relative">
        <input
          placeholder={placeholder}
          value={searchQuery}
          onChange={handleSearch}
          className="w-full border-none bg-transparent px-4 text-gray-400 outline-none focus:outline-none pr-20"
          type="text"
          name="search"
        />
        <div className="flex items-center">
          {searchQuery && (
            <button
              type="button"
              onClick={handleClearSearch}
              className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
              title="Clear search"
            >
              <IoMdClose className="h-4 w-4" />
            </button>
          )}
          <button
            type="submit"
            className="m-2 rounded bg-primary px-3 py-2 text-white"
          >
            <CiSearch className="h-4 w-4" />
          </button>
        </div>
      </div>
     
  
  );
};

export default SearchInput;
